import { DefaultSections, startPresentation } from "@presentation/Types";

import Introduction from "./Slides/IntroAndOutro/Introduction.vue";
import ThankYou from "./Slides/IntroAndOutro/ThankYou.vue";
import Partnership from "./Slides/Partnership/Partnership.vue";
import ConnectedVehiclesOverview from "./Slides/History/ConnectedVehiclesOverview.vue";
import OurHistory from "./Slides/History/OurHistory.vue";
import UsefulLinks from "./Slides/UsefulLinks/UsefulLinks.vue";
import CarbucksProtect from "./Slides/ConsumerProposition/CarbucksProtect.vue";
import CarbucksProtectVideo from "./Slides/ConsumerProposition/CarbucksProtectVideo.vue";
import CarbucksProtectCategories from "./Slides/ConsumerProposition/CarbucksProtectCategories.vue";
import Carparc from "./Slides/ConsumerProposition/Carparc.vue";
import ProtectSummary from "./Slides/ConsumerProposition/ProtectSummary.vue";
import TermsAndConditions from "./Slides/TermsAndConditions/TermsAndConditions.vue";
import CarbucksProtectProfit from "./Slides/ConsumerProposition/CarbucksProtectProfit.vue";
import CarbucksProtectFeatureList from "./Slides/ConsumerProposition/CarbucksProtectFeatureList.vue";
import CarbucksPointOfSale from "./Slides/PointOfSale/CarbucksPointOfSale.vue";

export const useSalesPresentation = () => startPresentation(
{

    key: 'carnex',
    title: 'Sales Presentation (Protect)',
    password: 'cvae', 
    enableNextSlideIndicator: true,

    theme: {
        logo: '/Carnex.png',
        textColor: '#262626',
        headerColor: '#2b85be',
        bgColorFrom: '#e0e0e0',
        bgColorTo: '#c0c0c0',
        navColorFrom: '#c59c56',
        navColorTo: '#c59c56',
        navBorderColor: '#26262677',
        nextButtonBackground: '#2b85be',
        nextButtonText: '#ffffff',
        triggerButtonBackground: '#10b981',
        triggerButtonText: '#ffffff',
        showImageOnTitlePages: false,
        showHorizonLine: false,
        keyMessageColor: '#2b85be'
    },

    sections: [

        // Introduction
        { 
            name: DefaultSections.Start, 
            title: 'Introduction',
            displayPageTitle: false,
            isAppendix: false,
            hasTitlePage: false,
            pages: [
                { title: '', component: Introduction,  }
            ],
            images: [
                '/carbucks-driven-by-presidian.png',
                '/carbucks-logo.png',
                '/protect-logo.png',
                '/protect-dashboard-logo.png',
                '/background-overlay.jpg',
                '/pending.jpg'
            ]
        },

        // Carbucks PROTECT
        { 
            name: 'carbucks-protect', 
            title: 'Carnex PROTECT',
            displayPageTitle: true,
            isAppendix: false,
            hasTitlePage: true,
            pages: [
                { component: CarbucksProtectVideo, title: 'What is PROTECT?' },
                { component: CarbucksProtect, title: 'Wear and Tear Cover' },
                { component: CarbucksProtectCategories, title: 'Great Benefits, Great Margins' },
                { component: CarbucksProtectFeatureList, title: 'Great Benefits, Great Margins' },
                { component: CarbucksProtectProfit, title: 'Great Benefits, Great Margins' },
                { component: Carparc, title: 'Comprehensive Dashboard' },
                { component: ProtectSummary, title: 'New Upfront Revenue' },
                // { component: EarlySignUpOffer, title: 'Limited Time Offer' }
            ],
            images: [
                '/ConsumerProposition/carbucks-rewards-logo.png',
                '/ConsumerProposition/carbucks-protect-logo.png',
                '/DealerProposition/early-bird-discount-smooth.png',
                '/DealerProposition/carbucks-dashboard-logo.png',
                '/background-overlay-4.jpg',
            ]   
        },

        // Thank You
        { 
            name: DefaultSections.End, 
            title: 'Questions',
            displayPageTitle: false,
            isAppendix: false,
            hasTitlePage: false,
            pages: [
                { component: ThankYou }
            ],
            images: [ 
                '/background-overlay-3.jpg',
            ]   
        },
        
        // Carbucks Rewards
        // { 
        //     name: 'carbucks-rewards', 
        //     title: 'Carbucks REWARDS',
        //     displayPageTitle: true,
        //     isAppendix: true,
        //     hasTitlePage: true,
        //     pages: [
        //         { component: CarbucksRewards, title: 'Consumer Proposition' },
        //         { component: RewardsSummary, title: 'Dealer Proposition' }
        //     ],
        //     images: [
        //         '/background-overlay-5.jpg',
        //     ]   
        // },

        // Case Study
        { 
            name: 'case-study'  
        },

        // Point of Sale
        { 
            name: 'point-of-sale', 
            title: 'Point of Sale',
            displayPageTitle: true,
            isAppendix: true,
            hasTitlePage: true,
            pages: [
                { component: CarbucksPointOfSale, title: 'Brochures, Pull-up Banners' }
            ],
            images: [
                '/PointOfSale/protect-pullup-banner.png',
                '/PointOfSale/protect-brochure.png',
            ]   
        },

        // Terms and Conditions
        { 
            name: 'terms-and-conditions', 
            title: 'Terms and Conditions',
            displayPageTitle: true,
            isAppendix: true,
            hasTitlePage: false,
            pages: [
                { component: TermsAndConditions }
            ],
            images: [
                '/TermsAndConditions/consumer-toc.png',
                '/TermsAndConditions/dealer-toc.png',
            ]   
        },

        // Dealer Cashback
        // { 
        //     name: 'dealer-cashback'  
        // },

        // DMS Integration
        // { 
        //     name: 'dms-integration'
        // },

        // Our History
        { 
            name: 'history', 
            title: 'Our History',
            displayPageTitle: true,
            isAppendix: true,
            hasTitlePage: false,
            pages: [
                { component: ConnectedVehiclesOverview, title: 'Company Overview', hideTitle: true },
                { component: OurHistory, title: 'Our History' },
            ],
            images: [
                '/History/connected-vehicles-logo-white.png',
                '/History/dealercell.jpg',
            ]   
        },

        // Partnership
        { 
            name: 'partnership', 
            title: 'AdTorque / CV Partnership',
            displayPageTitle: true,
            isAppendix: true,
            hasTitlePage: false,
            pages: [
                { component: Partnership }
            ],
            images: [
                '/connected-vehicles-logo.png',
                '/presidian-group-logo.png',
            ]   
        },

        // LINKS
        { 
            name: 'links', 
            title: 'Useful Links',
            displayPageTitle: true,
            isAppendix: true,
            hasTitlePage: false,
            pages: [
                { component: UsefulLinks }
            ],
            images: [

            ]   
        }

    ]

})
